import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		agentGrid: {
			display: 'flex', 
			alignItems: 'center'
		},
		agentLink: {
			fontSize: 15,
			color: theme.palette.primary.main,
			textDecoration: "none",
			whiteSpace: "nowrap",
			overflow: 'hidden', 
			textOverflow: 'ellipsis',
			maxWidth: "140px",
			"&:hover": {
				textDecoration: "underline"
			}
		},
		avatarLink: {
			textDecoration: "none",
			flexShrink: 0, 
			marginRight: 5
		},
		iconGrid: {
			marginTop: 5
		},
		unassignedIcon: {
			border: `3px solid ${theme.palette.primary.main}`,
			borderRadius: 50,
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
		},
		unassignedText: {
			paddingLeft: 5
		},
	} satisfies Record<string, CSSObject>);
